import { createSelector } from 'reselect'
import { get } from 'lodash'
import { tasksUnassignedParticipants as layout } from 'constants/layout'

const getAwards = state => get(state,
  'api.tasks.unassignedParticipants.list',
  [])


const getBulkAwardLeaderId = state => get(state,
  `form.${layout.bulkForm}.values.awardLeaderId`,
  '')

const mapForBulk = (awards, awardLeaderId) => {
  return awardLeaderId
    ? awards.filter(() => true)
      .map(p => get(p, 'award.id'))
    : []
}

export default createSelector([getAwards, getBulkAwardLeaderId],
  mapForBulk)
